import React from "react";
import DateTimeRange from "../../../components/common/DateTimeRange";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { url } from "../../../Constant";
import { useState } from "react";
import moment from "moment/moment";
import $ from "jquery";
import { toast } from "react-toastify";
import { useAuth } from "../../../Context/AuthProvider";
import { checkIndividualPermission } from "../../../Utils/PermissionFunctions";

const NewForwarding = () => {
  const { auth } = useAuth();
  const [callForwardingExtesnion, setCallForwardingExtesnion] = useState([]);
  const [errorEnable, setErrorEnable] = useState(false);
  const [loader, setLoader] = useState(false);
  const [similarError, setSimilarError] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [fileUploadError, setFileUploadError] = useState("");
  const [submittedData, setSubmittedData] = useState({
    call_forward_type: "",
    call_forward_from: "",
    call_forward_to: "",
    daterangefrom: "",
    daterangeto: "",
    is_sound_prompt: "",
    imagefile: "",
    vpbx_id: auth.vpbx_id,
  });

  const handleFile = (e) => {
    var file = e.target.files[0];
    var fileName = e.target.files[0].name;
    let fileNameSplit = fileName.split(".");
    let fileExtensionName = fileNameSplit[1];
    if (fileExtensionName !== "wav") {
      setFileUploadError("Please upload wav format file");
      setSubmittedData({
        ...submittedData,
        imagefile: "Invalid File",
      });
    } else {
      setFileUploadError("");
      setSubmittedData({
        ...submittedData,
        imagefile: file,
      });
    }
  };
  const getCallForwardingExtesnions = () => {
    let api = "";
    if (auth.role === "2") {
      api = "create-call-forwarding";
    } else {
      api = "user-create-call-forwarding";
    }
    axios
      .post(
        url + api,
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setCallForwardingExtesnion([]);
            } else if (response.data.message === "Data Found") {
              setCallForwardingExtesnion(response.data.data.extension);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  useEffect(() => {
    if (
      auth.role === "1" ||
      (auth.role === "3" &&
        !checkIndividualPermission("Forwarding", "read_and_write"))
    ) {
      window.location.href = "/";
    }
    getCallForwardingExtesnions();
  }, []);

  const createNewForwarding = () => {
    setErrorEnable(true);
    setLoader(true);
    var formData = new FormData();

    let isSoundPrompt = $("#is_sound_prompt").is(":checked") === true ? 1 : 0;
    formData.append("call_type", submittedData.call_forward_type);
    formData.append("from", submittedData.call_forward_from);
    formData.append("to", submittedData.call_forward_to);
    formData.append("status", isSoundPrompt);
    formData.append("start_datetime", moment(startDate).format("YYYY-MM-DD"));
    formData.append("end_datetime", moment(endDate).format("YYYY-MM-DD"));
    formData.append("vpbx_id", submittedData.vpbx_id);
    formData.append("userfile", submittedData.imagefile);

    if (submittedData.call_forward_from === submittedData.call_forward_to) {
      setSimilarError("Exist");
    }
    if (
      submittedData.call_forward_type !== "" &&
      submittedData.call_forward_from !== "" &&
      submittedData.call_forward_to !== "" &&
      startDate !== "" &&
      endDate !== "" &&
      fileUploadError === "" &&
      // submittedData.imagefile !== "" &&
      similarError === ""
    ) {
      let api = "";
      if (auth.role === "2") {
        api = "store-call-forwarding";
      } else {
        api = "user-store-call-forwarding";
      }
      axios
        .post(url + api, formData, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.status === 200) {
              if (
                response.data.message === "Call forwarding added successfully."
              ) {
                setLoader(false);
                toast.success(response.data.message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setTimeout(() => {
                  window.location.href = "/call-forwarding";
                }, 2000);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <Link to="/call-forwarding">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to VPBX manager</span>
                </Link>
                <h3>Create Call Forwarding</h3>
                <p>
                  Please provide the necessary details for the new call
                  forwarding, including the forwarding type, selected numbers,
                  and the duration period.
                </p>
              </div>
            </div>
          </div>

          <form action="javascript:void(0);">
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">Add details</legend>
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Call forwards type</label>
                  <select
                    className="uk-select"
                    aria-label="Select"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        call_forward_type: e.target.value,
                      });
                    }}
                  >
                    <option value="" selected>
                      Select call forward type
                    </option>
                    <option value="Unconditional">Unconditional</option>
                    <option value="Busy">Busy</option>
                    <option value="TimeOut">TimeOut</option>
                    <option value="Unavailable">Unavailable</option>
                  </select>
                  {errorEnable && submittedData.call_forward_type === "" && (
                    <div className="formErrors">
                      Call forward type is required
                    </div>
                  )}
                </div>
                <div className="uk-width-1-2@m uk-margin">
                  <label>During period</label>
                  <DateTimeRange
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    minDate={moment().toDate()}
                  />
                  {errorEnable && startDate === "" && endDate === "" && (
                    <div className="formErrors">During period is required</div>
                  )}
                </div>
                <div className="uk-width-1-2@m uk-margin">
                  <label>Call forward from</label>
                  <select
                    className="uk-select"
                    aria-label="Select"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        call_forward_from: e.target.value,
                      });
                      if (submittedData.call_forward_to === e.target.value) {
                        setSimilarError("Exist");
                      } else {
                        setSimilarError("");
                      }
                    }}
                  >
                    <option value="" selected>
                      Select call forward from
                    </option>
                    {callForwardingExtesnion.map((val, index) => {
                      return (
                        <option key={index} value={val.name}>
                          {val.name}
                        </option>
                      );
                    })}
                  </select>
                  {errorEnable && submittedData.call_forward_from === "" && (
                    <div className="formErrors">
                      Call forward from is required
                    </div>
                  )}
                </div>
                <div className="uk-width-1-2@m uk-margin">
                  <label>Call forward to</label>
                  <select
                    className="uk-select"
                    aria-label="Select"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        call_forward_to: e.target.value,
                      });
                      if (submittedData.call_forward_from === e.target.value) {
                        setSimilarError("Exist");
                      } else {
                        setSimilarError("");
                      }
                    }}
                  >
                    <option value="" selected>
                      Select call forward to
                    </option>
                    {callForwardingExtesnion.map((val, index) => {
                      return (
                        <option key={index} value={val.name}>
                          {val.name}
                        </option>
                      );
                    })}
                  </select>
                  {errorEnable && submittedData.call_forward_to === "" && (
                    <div className="formErrors">
                      Call forward to is required
                    </div>
                  )}
                </div>
                {errorEnable &&
                  submittedData.call_forward_to !== "" &&
                  submittedData.call_forward_from !== "" &&
                  similarError !== "" && (
                    <div className="uk-width-1-1@m formErrors">
                      source number and destination number shoud be different to
                      perform this action
                    </div>
                  )}
                {/* <div className="uk-width-1-2@m uk-margin">
                  <label>
                    <b>Play sound prompt</b>
                  </label>
                  <label className="CheckBoxLabel">
                    <input
                      className="uk-checkbox"
                      type="checkbox"
                      id="is_sound_prompt"
                    />
                    <span>Enable/Disable</span>
                  </label>
                </div>
                <div className="uk-width-1-1@m uk-margin-top">
                  <label>
                    <b>Upload .wav file</b>
                  </label>
                  <span className="fileDisc">
                    Add sound file (only .wav format allowed)
                  </span>
                  <div className="uk-margin-bottom">
                    <div uk-form-custom="target: true">
                      <input
                        type="file"
                        aria-label="Custom controls"
                        accept=".wav"
                        onChange={(e) => handleFile(e)}
                      />
                      <input
                        className="uk-input uk-form-width-medium"
                        type="text"
                        placeholder="Choose files"
                        aria-label="Custom controls"
                        disabled
                      />
                      {errorEnable && submittedData.imagefile === "" && (
                        <div className="formErrors">Please upload file</div>
                      )}
                      {errorEnable && fileUploadError !== "" && (
                        <div className="formErrors">{fileUploadError}</div>
                      )}
                    </div>
                    <button className="uk-button fileUploadBtn uk-button-default">
                      Submit
                    </button>
                  </div>
                  <a href="#" className="DownloadFileBtn">
                    {" "}
                    Download sample file
                  </a>
                </div> */}

                <div className="uk-width-1-1@m uk-float-right">
                  <div className="formActionBtn uk-text-right">
                    <button className="whiteBtn">Cancel</button>
                    <button
                      className="pinkBtn"
                      onClick={() => createNewForwarding()}
                    >
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Adding
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewForwarding;
